module.exports = __webpack_public_path__ + "static/media/pegnamindiapvtltd_logo.46f1ae9b.jpeg";